import { useEffect } from 'react';

/**
 * Set the tab title while a page is shown (buyer pages carry the seller's
 * or offer's name, not "Paywall Lab"); the previous title comes back on
 * unmount. A null title leaves the current one alone.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
